<template>
  <div class="animated fadeIn">
    <b-modal v-model="showModal" hide-footer>
      Você precisa ser cliente FREEPASS para solicitar a criação do seu Site pela nossa equipe.
      <b-row>
        <b-col>
          <b-button class="mt-3 bg-warning" block @click="showModal = false">Entendi</b-button>
        </b-col>
      </b-row>
      <br/>
      <br/>
    </b-modal>
    <br />
    <b-row class="mt-3">
      <b-col md="3" cols="6" v-for="(destination, index) in destinations" :key="index">
        <b-card>
          <b-row>
            <b-col class="text-center">
              <a href="#" @click="checkAndHandleClick(destination)">
                <h2><i :class="destination.icon"></i></h2>
                <div>{{destination.title}}</div>
              </a>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";
import { isIOS } from "mobile-device-detect";


export default {
  name: 'FreePassHome',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      destinations: [{
        title: "Modelos de Sticker",
        route: "https://giphy.com/sleeker",
        icon: "fa fa-user-circle-o",
        type: 1
      },
      /*{
        title: "Solicitar Sticker",
        route: "/freepass-sticker",
        icon: "fa fa-pencil",
        type: 0
      },*/
      {
        title: "Modelos de Vídeo",
        route: "/freepass-video",
        icon: "fa fa-play",
        type: 0
      },
      {
        title: "Apoio na Criação de Sites",
        route: "https://forms.gle/uqoK2W1KBhS8EjaW9",
        icon: "fa fa-laptop",
        type: 1,
        freepassOnly: true
      }],
      
      pendingEmailConfirmation: false,
      banner: {},
      isIOS: isIOS,
      showModal: false
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    }
  },
  methods: {
    checkAndHandleClick(destination) {
      if (!destination.freepassOnly || (this.me.subscription.planType == "FREEPASS" && !this.me.subscription.isExpired)) {
        this.handleClick(destination);
      } else {
        this.showModal = true;
      }
    },
    handleClick(destination) {
      window.location.href = destination.route
    },
    appBannerAction() {
      let url = "https://play.google.com/store/apps/details?id=pt.sleeker.androidapp";

      if (this.isIOS) {
        url = "https://apps.apple.com/us/app/sleeker/id1515716574"
      }

      window.open(url, "_blank");
    },
    bannerAction() {
      if (this.banner.destinationType == 0) {
        this.$router.push(this.banner.destination);
      } else {
        window.open(this.banner.destination, "_blank");
      }
    }
  },
  created() {
    service.getBanner().then(result => {
      this.banner = result.banner
      console.log(this.banner);
    });
    
    service.getMe().then(me => {
      this.me = me;
    })
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
